import { CircleCheck } from 'lucide-react-native';
import { twJoin } from 'tailwind-merge';

import { ON_YOUR_HONOR_ICON_GAP, ON_YOUR_HONOR_OUTLINE } from './OnYourHonorAction';

import { Button, ButtonIcon, ButtonText } from '@/components/ui/button';
import { ON_YOUR_HONOR_COPY } from '../../model/onYourHonor';

/**
 * Read-only replica of the unmarked "On your honor" toggle for narrative copy
 * (the intro banner). It is the real `Button` primitive in the same outline state
 * as the live toggle — identical size, action, variant, and shared color tokens —
 * so the pill renders the same on native and web rather than degrading to plain
 * text off-web.
 *
 * The check glyph and the label are both required, because the replica's whole job is
 * to be recognizable as the control the expert then goes looking for. Anything the
 * live toggle shows at rest has to show up here too, or the banner teaches a button
 * that does not exist.
 *
 * Inert and hidden from assistive tech: the interactive toggle sits in the composer
 * toolbar below, so this copy is purely illustrative. `pointerEvents="none"` keeps it
 * in its resting state (no hover fill), which is also why it carries only resting
 * colors and no hover or press variants. The a11y-hidden props stop screen readers
 * and keyboard focus from treating it as a second, dead button.
 */
export function OnYourHonorInlineBadge() {
  return (
    <Button
      size="2xs"
      action="secondary"
      variant="outline"
      focusable={false}
      pointerEvents="none"
      aria-hidden
      accessibilityElementsHidden
      importantForAccessibility="no-hide-descendants"
      className={twJoin(ON_YOUR_HONOR_ICON_GAP, ON_YOUR_HONOR_OUTLINE.border)}>
      <ButtonIcon as={CircleCheck} size="xs" className={ON_YOUR_HONOR_OUTLINE.text} />
      <ButtonText className={twJoin('text-sm', ON_YOUR_HONOR_OUTLINE.text)}>
        {ON_YOUR_HONOR_COPY.action}
      </ButtonText>
    </Button>
  );
}
